import React, { useState, useEffect } from 'react';
import { pushToDataLayer } from '../../assets/js/event-codes-helpers';
import { useIsMount } from '../../assets/js/custom-hooks';

const NewsletterSubscriptionEmailSubmit = ({newsLetterData, resourcedTexts, onSubmit}) => {
    const [firstName, setFirstName] = useState(newsLetterData.firstName);
    const [email, setEmail] = useState(newsLetterData.email);
    const [consent, setConsent] = useState(false);
    const isMount = useIsMount();
    const isDisabled = !consent || !firstName || !email;

    const changeConsent = () => {
        setConsent(!consent);
    }

    const handleSubmit = (e) => {
        if (newsLetterData.eventCodes.subscribe.length > 0) {
            pushToDataLayer(newsLetterData.eventCodes.subscribe);
        }

        e.preventDefault();
        if (isDisabled) return;
        onSubmit(email, firstName);
    }

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!isMount && newsLetterData.eventCodes.title.length > 0) {
                pushToDataLayer(newsLetterData.eventCodes.title);
            }
        }, 500);

        return () => {
            clearTimeout(timeout);
        };
    }, [firstName]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!isMount && newsLetterData.eventCodes.email.length > 0) {
                pushToDataLayer(newsLetterData.eventCodes.email);
            }
        }, 500);

        return () => {
            clearTimeout(timeout);
        }
    }, [email]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            if (!isMount && newsLetterData.eventCodes.consent.length > 0) {
                pushToDataLayer(newsLetterData.eventCodes.consent);
            }
        }, 500);

        return () => {
            clearTimeout(timeout);
        }
    }, [consent]);

    return (
        <form onSubmit={handleSubmit}>
            <div className="newsletter-subscription__panel">
                <h3 className="newsletter-subscription__title">{resourcedTexts.newsLetterTitle}</h3>
                <p>{resourcedTexts.newsLetterText}</p>

                <input
                    type="text"
                    placeholder={resourcedTexts.firstNamePlaceholder}
                    name="firstName"
                    title={resourcedTexts.firstNamePlaceholder}
                    aria-describedby="firstName"
                    value={firstName}
                    onChange={event => setFirstName(event.target.value)}
                    required
                />

                <input
                    type="email"
                    placeholder={resourcedTexts.emailPlaceholder}
                    name="email"
                    title={resourcedTexts.emailPlaceholder}
                    aria-describedby="email"
                    value={email}
                    onChange={event => setEmail(event.target.value)}
                    required
                />

                <div className={`checkout-agreement form-field checkbox-single`}>
                    <input id="newsletterConsent" type="checkbox" required onChange={changeConsent}/>
                    <label htmlFor="newsletterConsent">
                        <span dangerouslySetInnerHTML={{__html: resourcedTexts.subscribeConsentText}}/>
                    </label>
                </div>

                <button disabled={isDisabled}>
                    {resourcedTexts.subscribeButtonText}
                </button>
            </div>
        </form>
    )
}

export default NewsletterSubscriptionEmailSubmit;